import * as React from 'react';
import { ChangeEvent } from 'react';
import { AppContext, AppContextType } from '../../AppContextType';
import { Industry } from '../../Model/Industry';
import { JobCenterModelInterface } from '../../Model/JobCenterModelInterface';
import { IndustrySelectBox } from '../Form/IndustrySelectBox';
import { FilterViewProps } from './FilterViewProps';

export class IndustryFilter<T extends JobCenterModelInterface> extends React.PureComponent<FilterViewProps<T>> {
    public static contextType = AppContextType;
    public context: AppContext = {} as AppContext;

    constructor(props: FilterViewProps<T>, context: any) {
        super(props, context);
        this.handleChange = this.handleChange.bind(this);
    }

    public render() {
        const props = this.props;

        return <IndustrySelectBox valueId={props.filterSettings.industryId}
                                  models={props.models}
                                  placeholder={this.context.i18n.translate('Alle Branchen')}
                                  onChange={this.handleChange}/>;
    }

    private handleChange(value: Industry | undefined, _event: ChangeEvent<HTMLSelectElement>) {
        const props = this.props;

        props.onChange(props.filterSettings.withIndustryId(value ? value.referenceId : undefined));
    }
}
